"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'route.user.list': 'Usuarios',
    'route.user.create': 'Agregar Usuario',
    'route.user.edit': 'Editar Usuario',
};
